import { API_PREFIX } from '../../../shared/constants';
import { createRestClient, assertStatusCode } from '../rest';
import { FlashMessage } from '@pegasus/ui-flashmessages/types/flashmessage';

export interface Response {
    results: FlashMessage[];
}

export const fetchFlashMessages = (): Promise<Response> => {
    const client = createRestClient(API_PREFIX, false);

    return client
        .get(`/flashmessages`)
        .then(assertStatusCode([200]))
        .then(response => response.json())
        .catch(_ => [] as FlashMessage[])
        .then(messages => ({
            results: messages,
        }));
};
